<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'Site',
  };
</script>

<style lang="scss">
  /* FONT IMPORTS */
  @import url('https://fonts.googleapis.com/css?family=Gentium+Book+Plus');

  @font-face {
    font-family: 'SBLBibLit';
    src: local('SBLBibLit'), url(../public/fonts/SBLBibLit/SBLBibLit.woff);
  }
  /* END FONT IMPORTS */

  // Global body styles
  body {
    margin: 0;
  }
  #app {
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
      'Helvetica Neue', sans-serif;
    background: #bbb;
  }
</style>
